<template>
  <div>
    <div class="top">
      <img class="picimg" src="@/assets/image/联系我们.png" />
    </div>
    <div style="display: flex; align-items: center" class="prompt">
      <img class="icon" src="@/assets/images/zhuye.png" />
      <span class="color858"
        >&nbsp;&nbsp;你现在的位置&nbsp;&nbsp;/&nbsp;&nbsp;首页&nbsp;&nbsp;/&nbsp;&nbsp;</span
      >
      <span>联系我们</span>
    </div>
    <div class="titleBox">
      <span class="title">CONTACT US</span>
      <span class="title1">联系我们</span>
      <span class="line"></span>
    </div>
    <div class="topBox">
      <div>
        <p class="fw700">湖北毅瑞数据科技有限公司</p>
        <p>联系电话：13098823590</p>
        <p>企业邮箱：data@yiruibim.com</p>
        <p>地 址：武汉市武昌区武汉数创大厦23层</p>
      </div>
      <div id="localMap"></div>
    </div>
    <div class="titleBox">
      <span class="title">JOIN US</span>
      <span class="title1">加入我们</span>
      <span class="line"></span>
    </div>
    <div style="display: flex">
      <img class="kjimg" src="@/assets/image/加入我们.png" />
    </div>

    <div class="contentBox">
      <p class="fw700 fs18">方案经理</p>
      <p class="fw700">工作内容：</p>
      <p>1、负责需求调研，编制需求文档；</p>
      <p>
        2、收集相关业务方的需求，梳理出清晰的业务流程，形成产品方案，制作高保真原型；
      </p>
      <p>3、负责产品试用，做好产品质量内控；</p>
      <p>4、负责方案和产品交底，跟踪产品上线效果和用户反馈；</p>
      <p>5、完成上级领导交办的其他工作。</p>
      <p class="fw700">职位要求：</p>
      <p>1、计算机相关专业本科及以上学历，三年以上产品工作经验；</p>
      <p>
        2、逻辑思维能力强、学习能力强，有较强的业务抽象和系统设计能力，能够快速理解和掌握业务需求；
      </p>
      <p>3、自驱力强，有责任心，具备较好的沟通能力和项目推动能力。</p>
      <p>4、有良好的表达能力，能与内外部进行积极且有效的沟通；</p>
      <p>5、有TOB、TOG项目经验，大型项目经验者优先；</p>
      <p>6、有PMP或国家认证软考证书者优先。</p>
    </div>
    
    <Bottom />
    <Right />
  </div>
</template>

<script>
import Bottom from "./bottom.vue";
import Right from "./right.vue";
import Dibiao from "@/assets/images/dibiao.png";
import { loadTianditu } from "@/utils/tianditu.js";
import { gcj02ToWgs84 } from "@/utils/coord.js";

// 原高德中心点为 GCJ-02，天地图需 WGS84
const GCJ_LNG = 114.342911;
const GCJ_LAT = 30.591433;

export default {
  components: {
    Bottom,
    Right,
  },
  data() {
    return {
      map: null,
      marker: null,
    };
  },
  mounted() {
    this.initMap();
  },
  beforeDestroy() {
    this.map = null;
    this.marker = null;
  },
  methods: {
    async initMap() {
      try {
        const T = await loadTianditu();
        const [lng, lat] = gcj02ToWgs84(GCJ_LNG, GCJ_LAT);
        const lnglat = new T.LngLat(lng, lat);
        this.map = new T.Map("localMap");
        this.map.centerAndZoom(lnglat, 17);
        this.map.enableScrollWheelZoom();
        const icon = new T.Icon({
          iconUrl: Dibiao,
          iconSize: new T.Point(32, 32),
          iconAnchor: new T.Point(16, 32),
        });
        this.marker = new T.Marker(lnglat, { icon });
        this.map.addOverLay(this.marker);
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.topBox {
  margin: 20px 200px;
  #localMap {
    width: 100%;
    height: 400px;
    margin-top: 30px;
  }
  p {
    line-height: 50px;
    font-size: 18px;
  }
}
.kjimg {
  width: 624px;
  height: 983px;
  margin: 20px auto;
}
.contentBox {
  margin: 40px 200px;
  p {
    line-height: 30px;
    color: #333333;
  }
}
</style>
